import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { LangService } from '../../services/lang.service';
import {TranslateService} from '@ngx-translate/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ValidatorsService} from '../../services/validators/validators.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ApiService} from '../../services/api.service';
import {AppLockSessionComponent} from '../../shared/app-lock-session/app-lock-session.component';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
import {loaderConfig} from '../../config/loader';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {
  countries_en_payment,
  countries_es_payment,
  countries_pt_fixed,
  countries_pt_payment
} from '../../store/countries/country-data-store';
import { Location } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {

  /**
   * Indicate role of logged user (0: Gestor Flota, 1: Conductor)
   */
  public rolAcceso: number;

  /**
   * Indicate role who has permission to opperate fine (0: Gestor Flota, 1: Conductor)
   */
  public rolPermiso: number;

  /**
   * Indicate state of enlace (1: enviado, 2: pagado, 3: identificado, 4: compartido)
   */
  public acceso: number;

  /**
   * Session hash
   */
  private hash: string;

  /**
   * Param hash
   */
  private param_hash: string;

  /**
   * checksesInterval
   */
  private checksesInterval: any;

  /**
   * modal that lock a session
   */
  @ViewChild('lockSession') private lockSession: AppLockSessionComponent;

  /**
   * Fine data
   */
  public finedata: any;
  showView = false;
  public timeOut =  false;
  public diffDays: number;
  public diffHrs: number;
  public diffMins: number;
  public loaderOptions: any = loaderConfig;
  public currentLang: string;
  public creditCardYears: number[] = [];
  public validCardNumber = false;
  public month: number;
  public year: number;
  public validExpirationDate = false;
  public showCreditCardForm = false; // poner en true cuando se implemente el pago por tarjeta
  public showPayPalForm = false;
  public showMultibancoForm = true; // poner en false cuando se implemente el pago por tarjeta
  public countries_en: any = countries_en_payment;
  public countries_es: any = countries_es_payment;
  public countries_pt: any = countries_pt_payment;

  paymentForm: FormGroup = this.formBuilder.group({
    name: ['', [Validators.required] ],
    cvv: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4)]],
    ccmonth: ['', Validators.required],
    ccyear: ['', Validators.required],
    ccnumber: ['', Validators.required],
  });

  invoiceForm: FormGroup = this.formBuilder.group({
    nombreFacturacion: ['', [Validators.required] ],
    direccionFacturacion: ['', [Validators.minLength(3)]],
    documentoFacturacion: ['', [Validators.required]],
    emailFacturacion: ['', [Validators.pattern(this.vs.emailPattern)]],
    cpostalFacturacion: [''],
    paisFacturacion: ['Portugal', [Validators.required] ],
    ciudadFacturacion: [''],
    telefonoFacturacion: ['', [Validators.minLength(9), Validators.maxLength(15), Validators.pattern(this.vs.phonePattern)]]
  });

  public submitted = false;
  public submittedMultibanco = false;
  success = false;
  error = false;
  loading = false;
  public files = [];
  public summary = [];
  public totalAmount = 0;
  public totalFees = 0;
  public vat = 0;
  public fines = [];
  public fineInfo: any;
  public actualModalFineIndex: number;
  public summaryFines = [];
  public summaryTotals = {};
  public needsInvoice = false;
  public needsNIFValidation = true;
  public documentPlaceholder = '';
  public totalsOver1000 = false;
  public nifError = true;
  private idsEnlace: any[] = [];

  constructor(private router: Router,
              private authService: AuthService,
              private lang: LangService,
              private route: ActivatedRoute,
              private apiService: ApiService,
              private translate: TranslateService,
              private http: HttpClient,
              private formBuilder: FormBuilder,
              private vs: ValidatorsService,
              private ngxLoader: NgxUiLoaderService,
              private location: Location,
              private modalService: NgbModal) {
    this.hash = this.authService.getHash();

    this.route.params.subscribe(params => {
      this.param_hash = params['hash'];
    });
  }

  ngOnInit() {
    this.ngxLoader.start();
    this.documentPlaceholder = this.translate.instant('PaymentPage.Form.Data.Invoicing.DocumentPlaceholder.Portugal');
    this.files = JSON.parse(localStorage.getItem('expedientes'));
    this.summary = JSON.parse(localStorage.getItem('summary'));
    this.summary.forEach((value) => {
      this.totalAmount += value.importeBrutoSinDescuento;
      this.totalFees += value.comisionConDescuento;
    });
    this.vat = this.totalFees * 23 / 100;
    this.currentLang = this.lang.getLang();
    const currentYear = (new Date()).getFullYear();
    this.year = currentYear;
    const maxYear = currentYear + 30;
    let count = 0;
    for (let i = currentYear; i < maxYear; i++) {
      this.creditCardYears[count] = currentYear + count;
      count++;
    }
    // if session hash is different from hash of route eject from session to login page.
    if (this.hash !== this.param_hash) {
      this.lockSession.open();
      return false;
    }

    this.checksesInterval = setInterval(() => {
      this.hash = this.authService.getHash();
      if (this.hash !== this.param_hash) {
        this.lockSession.open();
        clearInterval(this.checksesInterval);
        return false;
      }

    }, 1000 * 60);

    const expedientes = JSON.parse(localStorage.getItem('expedientes'));

    this.apiService.getFineData(`${this.hash}`)
        .subscribe((response: any) => {
          this.fines = response;
          this.idsEnlace = response.filter(fine => expedientes.includes(fine.expedienteGesthispania)).map(fine => fine.idEnlace);
          for (let i = 0; i < this.fines.length; i++) {
            for (let j = 0; j < this.summary.length; j++) {
              if (this.fines[i].expedienteGesthispania === this.summary[j].expedienteGesthispania) {
                this.summaryFines.push(this.fines[i]);
              }
            }
          }
          if (response[0] !== undefined) {
            this.finedata = response[0];
          } else {
            this.finedata = response;
          }
          this.acceso = this.finedata.acceso;
          this.rolAcceso = this.finedata.rolAcceso;
          this.rolPermiso = this.finedata.rolPermiso;
          const fechaHoraServidor = this.finedata.fechaHoraServidor.date;
          const fechaFinEnlace = this.finedata.fechaFinEnlace.date;
          const dateExpires = new Date(fechaFinEnlace.replace(' ', 'T'));
          const nowdate = new Date(fechaHoraServidor.replace(' ', 'T'));
          if (nowdate.getTime() > dateExpires.getTime()) {
            this.timeOut = true;
          } else {
            const diffMs = Math.abs(dateExpires.getTime() - nowdate.getTime() );
            this.diffDays = Math.floor(diffMs / 86400000);
            this.diffHrs = Math.floor((diffMs % 86400000) / 3600000);
            this.diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
          }
          this.ngxLoader.stop();
          this.ejectFromRoute();
          this.getSummaryTotals();
        });
  }

  viewFine() {
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;
    if ( this.paymentForm.invalid ) {
      this.markFormGroupTouched(this.paymentForm);
      return;
    }
    if ( this.invoiceForm.invalid ) {
      this.markFormGroupTouched(this.invoiceForm);
      return;
    }
    this.submitted = true;
    const dataForm = this.paymentForm.value;
    const dataInvoiceForm = this.invoiceForm.value;
    this.payFine({...dataForm, ...dataInvoiceForm});
  }

  payMultibanco() {
    let params = {
      'nombreFacturacion' : 'Consumidor final',
      'documentoFacturacion' : '999999990',
      'direccionFacturacion' : '',
      'cpostalFacturacion' : '',
      'paisFacturacion' : 'Portugal',
      'ciudadFacturacion' : '',
      'telefonoFacturacion' : '',
      'emailFacturacion' : '',
      'expedientes': this.files
    };
    if (this.needsInvoice) {
      const dataInvoiceForm = this.invoiceForm.value;
      params = {
        'nombreFacturacion' : dataInvoiceForm['nombreFacturacion'],
        'documentoFacturacion' : dataInvoiceForm['documentoFacturacion'],
        'direccionFacturacion' : dataInvoiceForm['direccionFacturacion'],
        'cpostalFacturacion' : dataInvoiceForm['cpostalFacturacion'],
        'paisFacturacion' : dataInvoiceForm['paisFacturacion'],
        'ciudadFacturacion' : dataInvoiceForm['ciudadFacturacion'],
        'telefonoFacturacion' : dataInvoiceForm['telefonoFacturacion'],
        'emailFacturacion' : dataInvoiceForm['emailFacturacion'],
        'expedientes': this.files
      };
    }
    this.loading = true;
    this.error = false;
    this.success = false;
    const URL_API = environment.URL_API;
    const url = URL_API + this.authService.getHash() + '/iniciapago';
    const headers: HttpHeaders = new HttpHeaders().set('TOKEN', this.authService.getToken());
    return this.http.post<any>(url, params, {headers}).subscribe(
        data => {
          this.authService.logout();
          window.location.href = data['URL'];
        },
        error => {
          this.loading = false;
          this.error = true;
          setTimeout(() => {
            this.error = false;
          }, 3000);
        }
    );
  }

  payFine(dataform) {
    const params = {
      'name' : dataform['name'],
      'ccnumber' : dataform['ccnumber'].replaceAll(' ', ''),
      'cvv' : dataform['cvv'],
      'ccmonth' : dataform['ccmonth'],
      'ccyear' : dataform['ccyear'],
      'nombreFacturacion' : dataform['nombreFacturacion'],
      'documentoFacturacion' : dataform['documentoFacturacion'],
      'direccionFacturacion' : dataform['direccionFacturacion'],
      'expedientes': this.files
    };
    this.loading = true;
    this.error = false;
    this.success = false;
    const URL_API = environment.URL_API;
    const url = URL_API + 'pagar/' + this.authService.getHash();
    const headers: HttpHeaders = new HttpHeaders().set('TOKEN', this.authService.getToken());
    return this.http.post<any>(url, params, {headers}).subscribe(
        data => {
          setTimeout(() => {
            this.loading = false;
            Swal.fire({
              title: this.translate.instant('AppLockSession.paying.header'),
              text: this.translate.instant('AppLockSession.paying.body'),
              confirmButtonColor: '#050B7F',
              confirmButtonText: '<i class="fa fa-chevron-right"></i> ' + this.translate.instant('AppLockSession.paying.button'),
              allowOutsideClick: false,
              allowEscapeKey: false,
              type: 'success'
            }).then((result) => {
              if (result.value) {
                this.viewFine();
              }
            });
          }, 3000);
        },
        error => {
          this.success = false;
          this.error = true;
          this.loading = false;
        }
    );
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  get form() {
    return this.paymentForm.controls;
  }

  get form2() {
    return this.invoiceForm.controls;
  }

  fieldIsValid(campo: string) {
    return this.invoiceForm.controls[campo].errors && this.invoiceForm.controls[campo].touched;
  }

  get documentoFacturacionErrorMsg(): string {
    const errors = this.invoiceForm.get('documentoFacturacion').errors;
    let msg = '';
    if ( errors.required ) {
      msg = this.translate.instant('PaymentPage.Form.Data.Invoicing.NIFErrorMessage.Required');
      return msg;
    } else if ( errors.incorrecto ) {
      msg = this.translate.instant('PaymentPage.Form.Data.Invoicing.NIFErrorMessage.Format');
      return msg;
    }
    return msg;
  }

  get nombreFacturacionErrorMsg(): string {
    const errors = this.invoiceForm.get('nombreFacturacion').errors;
    let msg = '';
    if ( errors.required ) {
      msg = this.translate.instant('PaymentPage.Form.Data.Invoicing.NameErrors.Required');
      return msg;
    } else {
      msg = this.translate.instant('PaymentPage.Form.Data.Invoicing.NameErrors.Format');
      return msg;
    }
  }

  maskCardNumber(cardNumber) {
    let masked = '';
    for (let i = 0; i < cardNumber.length; i++) {
      if (i === 3 || i === 7 || i === 11) {
        masked += cardNumber[i] + ' ';
      } else {
        masked += cardNumber[i];
      }
    }
    this.paymentForm.controls['ccnumber'].setValue(masked);
  }

  validateCardNumber(cardNumber) {
    if (!cardNumber.length) {
      return;
    }
    cardNumber = cardNumber.replace(/\s/g, '');
    this.maskCardNumber(cardNumber);
    const lastDigit = Number(cardNumber[cardNumber.length - 1]);
    const reverseCardNumber = cardNumber
        .slice(0, cardNumber.length - 1)
        .split('')
        .reverse()
        .map(x => Number(x));
    let sum = 0;
    for (let i = 0; i <= reverseCardNumber.length - 1; i += 2) {
      reverseCardNumber[i] = reverseCardNumber[i] * 2;
      if (reverseCardNumber[i] > 9) {
        reverseCardNumber[i] = reverseCardNumber[i] - 9;
      }
    }
    sum = reverseCardNumber
        .reduce((acc, currValue) => (acc + currValue), 0);
    this.validCardNumber = (sum + lastDigit) % 10 === 0;
    if (this.validCardNumber && (cardNumber.startsWith('5') || cardNumber.startsWith('2') || cardNumber.startsWith('4'))) {
      this.paymentForm.controls['ccnumber'].setErrors(null);
    } else {
      this.paymentForm.controls['ccnumber'].setErrors({'incorrect': true});
    }
  }

  setExpirationMonth(month) {
    this.month = parseInt(month, 0);
    this.validateExpirationDate();
  }

  setExpirationYear(year) {
    this.year = parseInt(year, 0);
    this.validateExpirationDate();
  }

  validateExpirationDate() {
    const currentMonth = new Date().getMonth() + 1;
    const currentYear = new Date().getFullYear();
    this.validExpirationDate = !(currentYear === this.year && this.month < currentMonth);
    if (this.validExpirationDate) {
      this.paymentForm.controls['ccmonth'].setErrors(null);
      this.paymentForm.controls['ccyear'].setErrors(null);
    } else {
      this.paymentForm.controls['ccmonth'].setErrors({'incorrect': true});
      this.paymentForm.controls['ccyear'].setErrors({'incorrect': true});
    }
  }

  ejectFromRoute() {
    let allowed = false;
    for (let i = 0; i < this.summaryFines.length; i++) {
      if (this.summaryFines[i].timeOut) {
        allowed = false;
      } else {
        if (this.summaryFines[i].acceso === 1) {
          if (this.summaryFines[i].rolAcceso === this.summaryFines[i].rolAcceso) {
            allowed = true;
          }
        } else {
          if ((this.summaryFines[i].rolAcceso === 1 || this.summaryFines[i].rolAcceso === 2) && this.summaryFines[i].acceso === 4) {
            allowed = true;
          }
        }
      }
    }
    if (!allowed) {
      this.viewFine();
    } else {
      this.showView = true;
    }
  }

  selectPaymentMethod(event) {
    const selectedMethod: string = (event.target as Element).id;
    switch (selectedMethod) {
      case 'cc-card':
        this.showCreditCardForm = true;
        this.showPayPalForm = false;
        this.showMultibancoForm = false;
        break;
      case 'paypal-card':
        this.showCreditCardForm = false;
        this.showPayPalForm = true;
        this.showMultibancoForm = false;
        break;
      case 'multibanco-card':
        this.showCreditCardForm = false;
        this.showPayPalForm = false;
        this.showMultibancoForm = true;
        break;
      case 'cc':
        this.showCreditCardForm = true;
        this.showPayPalForm = false;
        this.showMultibancoForm = false;
        break;
      case 'paypal':
        this.showCreditCardForm = false;
        this.showPayPalForm = true;
        this.showMultibancoForm = false;
        break;
      case 'multibanco':
        this.showCreditCardForm = false;
        this.showPayPalForm = false;
        this.showMultibancoForm = true;
        break;
      default:
        this.showCreditCardForm = true;
        this.showPayPalForm = false;
        this.showMultibancoForm = false;
        break;
    }
  }

  showFineInModal(expedienteGesthispania?: any, modal1?, position?: number) {
    if (position === 0) {
      for (let i = 0; i < this.summaryFines.length; i++) {
        if (this.summaryFines[i].expedienteGesthispania === expedienteGesthispania) {
          this.fineInfo = this.summaryFines[i];
          this.actualModalFineIndex = i;
        }
      }
      this.modalService.dismissAll();
      this.modalService.open(modal1, {size: 'lg', centered: true, windowClass: 'animated fadeIn'});
    } else if (position === 1) {
      this.fineInfo = this.summaryFines[this.actualModalFineIndex + 1];
      this.actualModalFineIndex++;
    } else {
      this.fineInfo = this.summaryFines[this.actualModalFineIndex - 1];
      this.actualModalFineIndex--;
    }
  }

  private getSummaryTotals() {
    const body = {
      'idEnlaces': this.idsEnlace
    };
    const URL_API = environment.URL_API;
    const url = URL_API + this.authService.getHash() + '/resumenpago';
    const headers: HttpHeaders = new HttpHeaders().set('TOKEN', this.authService.getToken());
    return this.http.post<any>(url, body, {headers}).subscribe(
        data => {
          this.summaryTotals = data;
          if (parseFloat(this.summaryTotals['importeTotal']) >= 1000.00) {
            this.totalsOver1000 = true;
            this.needsInvoice = true;
          }
        },
        error => {
          console.error(error);
        }
    );
  }

  validateNIF(nif) {
    this.nifError = true;
    if (this.needsNIFValidation) {
      const validationSets = {
        one: ['1', '2', '3', '5', '6', '8'],
        two: ['45', '70', '71', '72', '74', '75', '77', '79', '90', '91', '98', '99']
      };
      if (nif.length !== 9) {
        this.invoiceForm.controls['documentoFacturacion'].setErrors({'incorrecto': true});
      }
      if (!validationSets.one.includes(nif.substr(0, 1)) && !validationSets.two.includes(nif.substr(0, 2))) {
        this.invoiceForm.controls['documentoFacturacion'].setErrors({'incorrecto': true});
      }
      // tslint:disable-next-line:radix
      const nifNumbers = nif.split('').map(c => Number.parseInt(c));
      const total = nifNumbers[0] * 9 +
          nifNumbers[1] * 8 +
          nifNumbers[2] * 7 +
          nifNumbers[3] * 6 +
          nifNumbers[4] * 5 +
          nifNumbers[5] * 4 +
          nifNumbers[6] * 3 +
          nifNumbers[7] * 2;
      const modulo11 = (Number(total) % 11);
      const checkDigit = modulo11 < 2 ? 0 : 11 - modulo11;
      if (!(checkDigit === Number(nif[8]))) {
        this.invoiceForm.controls['documentoFacturacion'].setErrors({'incorrecto': true});
      } else {
        this.invoiceForm.controls['documentoFacturacion'].setErrors(null);
        this.nifError = false;
      }
    } else {
      if (nif.length === 0) {
        this.invoiceForm.controls['documentoFacturacion'].setErrors({'required': true});
        this.nifError = true;
      } else {
        this.invoiceForm.controls['documentoFacturacion'].setErrors(null);
        this.nifError = false;
      }
    }
  }

  checkNeedsInvoice() {
    this.needsInvoice = !this.needsInvoice;
  }

  onCountrySelect(value) {
    if (value === 'Portugal') {
      this.needsNIFValidation = true;
      this.documentPlaceholder = this.translate.instant('PaymentPage.Form.Data.Invoicing.DocumentPlaceholder.Portugal');
    } else {
      this.needsNIFValidation = false;
      this.documentPlaceholder = this.translate.instant('PaymentPage.Form.Data.Invoicing.DocumentPlaceholder.International');
    }
    this.validateNIF(this.invoiceForm.controls['documentoFacturacion'].value);
  }

}
